module.exports = __webpack_public_path__ + "static/media/bietro.273926b4.jpg";